import type { CustomStoreImplementationOptions, KaElementMap, MergeCustomStore, StoreIdentifier } from 'kapix-components-vue3'
import { defineStore } from 'pinia'
import { initAliveStoreIds, kapixContext, openUrl, remove, scrollInfo } from 'kapix-components-vue3'
import formationsGrowthHackingStoreCustom from './store.custom'
import { $translate } from '~/modules/i18n'

const storeName = 'formationsGrowthHacking'
const customImplement: CustomStoreImplementationOptions = formationsGrowthHackingStoreCustom.options
const aliveStoreIds = initAliveStoreIds()

function formationsGrowthHackingFactory (storeId?: Nullable<StoreIdentifier>) {
  return defineStore(storeId == null ? storeName : `${storeName}/${storeId}`, {
    state: () => {
      return {
        $aliveStoreIds: aliveStoreIds,
        $subStoreIds: 1,
        $storeId: storeId,
        $emit: (() => {}) as (propName: any, value: any) => void,
        $elements: {} as KaElementMap,
        $router: kapixContext.isClient ? kapixContext.$router : undefined,
        $route: kapixContext.isClient ? kapixContext.$route : undefined,
        // Page info,
        $title: $translate('prog-04-growth-hacking.title', 'Formation en growth hacking sur-mesure'),
        $description: $translate('prog-04-growth-hacking.description', 'Offrez une croissance rapide et digitalisée à votre entreprise grâce à une formation en growth hacking sur-mesure par l\'un de vos experts Matchers ! '),
        $publishedTime: new Date('2023-02-13T07:42:17.591Z'),
        $modifiedTime: new Date('2023-11-03T23:50:03.824Z'),
        // Constants,
        $constants: {
          blocPreviewProfilExpertTags: [
            { Nom: 'Email Marketing' },
            { Nom: 'Audit SEO/SEA' },
            { Nom: 'Growth Marketing' },
            { Nom: 'Conversion' },
            { Nom: 'Taux de conversion' },
            { Nom: 'Google Ads' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element1Tags: [
            { Nom: 'Acquisition de trafic' },
            { Nom: 'E-commerce' },
            { Nom: 'Campagnes webmarketing' },
            { Nom: 'SEA' },
            { Nom: 'Google Analytics' },
            { Nom: 'Social selling' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element2Tags: [
            { Nom: 'Lead generation' },
            { Nom: 'Automation' },
            { Nom: 'Python' },
            { Nom: 'SQL' },
            { Nom: 'Analyse de données' },
            { Nom: 'Base de données' },
            { Nom: 'Lemlist' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          element3Tags: [
            { Nom: 'Outbound' },
            { Nom: 'Web Scraping' },
            { Nom: 'API' },
            { Nom: 'Marketing automation' },
            { Nom: 'Hubspot' },
            { Nom: 'Zapier' },
            { Nom: 'CRM' },
            { Nom: 'Growth strategy' }
          ] as PartialEntities<Kapix.Entity.ITagsExperts>,
          dropDownFormationArguments: [
            { Text: '<ul><li>Définir son potentiel marché : territoires, capacités de production.</li></ul>' },
            { Text: '<ul><li>&nbsp;Identifier sa cible, ses personas et leurs parcours d\'utilisation.&nbsp;</li></ul>' },
            { Text: '<ul><li>Mettre en place les techniques de récupération d’informations pour construire un fichier de prospects.&nbsp;</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element4Arguments: [
            { Text: '<ul><li>Connaître les techniques performantes de prospection digitale.</li></ul>' },
            { Text: '<ul><li>Savoir évaluer la performance des outils de prospection digitale en lien avec la commercialisation de son service.</li></ul>' },
            { Text: '<ul><li>Appréhender le marché de la recherche en ligne.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element5Arguments: [
            { Text: '<ul><li>Savoir analyser son dispositif digital.&nbsp;</li></ul>' },
            { Text: '<ul><li>Savoir compléter utilement son dispositif digital.</li></ul>' },
            { Text: '<ul><li>Exploiter des actions d’emailing.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element6Arguments: [
            { Text: '<ul><li>Évaluer les avantages d\'allier les stratégies.</li></ul>' },
            { Text: '<ul><li>Identifier les limites du CRM.</li></ul>' },
            { Text: '<ul><li>Mise en place opérationnelle d\'un outil de marketing automation scalable.</li></ul>' },
            { Text: '<p>Sélection d’un outil de marketing automation adapté à son marché.</p>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element7Arguments: [
            { Text: '<ul><li>Élaborer des scénarios de conversions.</li></ul>' },
            { Text: '<ul><li>&nbsp;Tester des scénarios de conversion.</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>,
          element8Arguments: [
            { Text: '<ul><li>Définir des objectifs en termes de revenus.</li></ul>' },
            { Text: '<ul><li>Définir les indicateurs clés de performance, les Kpis.</li></ul>' },
            { Text: '<ul><li>Analyser la pertinence des leads de marketing (MQL) et des leads de ventes (SQL).</li></ul>' },
            { Text: '<ul><li>Mise en place d’un dashboard macro et micro (KPI business, Cohortes, Statistiques par canaux...).</li></ul>' }
          ] as PartialEntities<Kapix.Entity.IDropDownFormation>
        },
        // Data,
        $info: { prog04GrowthHacking: scrollInfo() },
        ...(customImplement.state && customImplement.state())
      }
    },
    getters: {
      ...customImplement.getters
    },
    actions: {
      /* @ts-ignore: to allow override in your custom file */
      blocPreviewProfilExpertClick () {
        openUrl('https://www.matchers.fr/expert/486', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element1Click () {
        openUrl('https://www.matchers.fr/expert/318', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element2Click () {
        openUrl('https://www.matchers.fr/expert/247', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      element3Click () {
        openUrl('https://www.matchers.fr/expert/333', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      voirClick () {
        openUrl('https://www.matchers.fr/experts', '_self')
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        return storeId != null ? getStoreInstance(storeId) : this
      },
      /* @ts-ignore: to allow override in your custom file */
      getStoreInstances () {
        return aliveStoreIds.map(storeId => this.getStoreInstance(storeId))
      },
      /* @ts-ignore: to allow override in your custom file */
      newStoreInstance (storeId?: Nullable<StoreIdentifier>) {
        const newStoreId = storeId || this.$subStoreIds++
        if (aliveStoreIds.includes(newStoreId)) {
          throw new Error(`Store with id ${storeId} already exists`)
        }
        aliveStoreIds.push(newStoreId)
        return getStoreInstance(newStoreId)
      },
      ...customImplement.actions,
      /* @ts-ignore: to allow override in your custom file */
      beforeMount () {
        customImplement.actions?.beforeMount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      mounted () {
        customImplement.actions?.mounted?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      async serverPrefetch () {
        await customImplement.actions?.serverPrefetch?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      beforeUnmount () {
        customImplement.actions?.beforeUnmount?.call(this)
      },
      /* @ts-ignore: to allow override in your custom file */
      unmounted () {
        if (this.$storeId != null) {
          this.$dispose()
          remove(aliveStoreIds, this.$storeId)
        }
        customImplement.actions?.unmounted?.call(this)
      }
    }
  })
}

function getStoreInstance (storeId?: Nullable<StoreIdentifier>) {
  return formationsGrowthHackingFactory(storeId)()
}

export const formationsGrowthHackingRaw = formationsGrowthHackingFactory()
export const formationsGrowthHacking = () => formationsGrowthHackingRaw() as MergeCustomStore<typeof formationsGrowthHackingStoreCustom.instance>
